import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import store from "../store";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        component: index
    },
]

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async (to, from, next) => {
    if (!store.state.userInfo.globalUserId) {
        await store.dispatch("userInfo/init");
    }
    next();
});
export default router
